export enum SocketEvent {
  STATUS_PING = 'status:ping',
  STATUS_PONG = 'status:pong',

  ARTICLE_GENERATE_PRIMARY_KEYWORD = 'article:generate_primary_keyword',
  ARTICLE_GENERATE_PRIMARY_PROMPT = 'article:generate_primary_prompt',
  CONTENT_UPDATE = 'content:update',
  CONTENT_PROMPT_UPDATE = 'content:prompt_update',

  BULK_GROUP_UPDATE = 'bulk_group:update',
  PRODUCT_UPDATE = 'product:update',

  BRAND_GENERATE_CONTEXT = 'brand:generate_context',

  SEO_STRATEGY_UPDATE = 'seo_strategy:update',

  ORGANIZATION_UPDATE = 'organization:update',
  USER_UPDATE = 'user:update',
}
